import { Route, Routes } from 'react-router-dom';
import GreenHubListPage from './list';
import GreenHubDetailPage from './detail';
import CreateBlogPage from './create';

export default function GreenHubRouting() {
  return (
    <Routes>
      <Route index element={<GreenHubListPage />} />
      <Route path="/create" element={<CreateBlogPage />} />
      <Route path="/:id" element={<GreenHubDetailPage />} />
    </Routes>
  );
}
